export const SET_LOADING = "SET_LOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";
export const SET_OPEN_MODAL = "SET_OPEN_MODAL";
export const SET_EXT_DATA_GROUP = "SET_EXT_DATA_GROUP";


export const GET_EXT_DATA_GROUPS = "GET_EXT_DATA_GROUPS";
export const GET_EXT_DATA_GROUPS_SUCCESS = "GET_EXT_DATA_GROUPS_SUCCESS";
export const GET_EXT_DATA_GROUPS_FAILURE = "GET_EXT_DATA_GROUPS_FAILURE";

export const GET_EXT_DATA_GROUP = "GET_EXT_DATA_GROUP";
export const GET_EXT_DATA_GROUP_SUCCESS = "GET_EXT_DATA_GROUP_SUCCESS";
export const GET_EXT_DATA_GROUP_FAILURE = "GET_EXT_DATA_GROUP_FAILURE";

export const CREATE_EXT_DATA_GROUP = "CREATE_EXT_DATA_GROUP";
export const CREATE_EXT_DATA_GROUP_SUCCESS = "CREATE_EXT_DATA_GROUP_SUCCESS";
export const CREATE_EXT_DATA_GROUP_FAILURE = "CREATE_EXT_DATA_GROUP_FAILURE";

export const UPDATE_EXT_DATA_GROUP = "UPDATE_EXT_DATA_GROUP";
export const UPDATE_EXT_DATA_GROUP_SUCCESS = "UPDATE_EXT_DATA_GROUP_SUCCESS";
export const UPDATE_EXT_DATA_GROUP_FAILURE = "UPDATE_EXT_DATA_GROUP_FAILURE";

export const DELETE_EXT_DATA_GROUP = "DELETE_EXT_DATA_GROUP";
export const DELETE_EXT_DATA_GROUP_SUCCESS = "DELETE_EXT_DATA_GROUP_SUCCESS";
export const DELETE_EXT_DATA_GROUP_FAILURE = "DELETE_EXT_DATA_GROUP_FAILURE";

export const UPDATE_EXT_DATA_GROUPS_ORDER = "UPDATE_EXT_DATA_GROUPS_ORDER";
export const UPDATE_EXT_DATA_GROUPS_ORDER_SUCCESS = "UPDATE_EXT_DATA_GROUPS_ORDER_SUCCESS";
export const UPDATE_EXT_DATA_GROUPS_ORDER_FAILURE = "UPDATE_EXT_DATA_GROUPS_ORDER_FAILURE";